import {
    DiscountEnumType,
    FundingEnumType,
    ObligationType,
    PlanRange,
    ProductTypeId,
    SimType,
    TECHNOLOGY,
} from '@app-types/product';

import { PlanTypeId, ProductType } from '@constants/plan';

export type ApiOptionType = {
    type_id: ProductTypeId;
    price: number;
    name: string;
    description?: string;
    short_description?: string;
    gencode: string;
    thumbnail?: string;
    small_image: string;
    wording_promo: string;
    position?: string;
    pennant_text: string;
    background_image?: {
        public_url?: string;
    };
    background_image_portrait?: {
        public_url?: string;
    };
};

export type ApiProductType = {
    gencode: string;
    type_id: ProductTypeId;
    price: number;
    name: string;
    position: string;
    data_size: number;
    url_key: string;
    data_envelope: string;
    // options: ApiOptionType[];
    upSellsProducts?: string[];
    commercial_range: string;
    categories: string[];
    in_stock: boolean;
    roaming_envelope: string;
    roaming: boolean;
    prime?: boolean;
    promoEndDate: string;
    promoShowEndDate: boolean;
    highLight?: boolean;
    sms_clean: string;
    newprice: number;
    serieSpecial: string | null;
    bg_price_card?: string;
    spotify?: string;
    spotifyFreeMonth?: string;
    max_connection?: '4g' | '5g';
    from_abroad?: string;
    freeMonth?: string;
    textIntl?: string;
    bannerText: string | null;
    bandeauText?: string;
    goYear2?: string;
    option?: string;
    dureePromo?: number;
    valeurRemise?: number;
    network5g?: string;
    isForfaitHesitante?: boolean;
    sims: SimType[];
    locked?: string;
    networkText?: string;
    service_max?: boolean;
    price_type: string;
    to_add_front?: string;

    //ssr
    sms_mms: string;
    montantRemise?: number;
};

export type ApiProductsPromoType = {
    gencode: string;
    promotion: {
        id: number;
        produitAAjouter: string;
        nom: string;
        type: string;
        description: string;
        duree: number;
        odr: boolean;
        dates: {
            debut: string;
            fin: string;
        };
        typeRemise: string;
        valeurRemise: number;
        valeurRemiseReelle: number;
        aUnePortabilite: boolean;
        conditionneeSurRioNonPartenaire: boolean;
        typesAcces: string[];
    }[];
};

export type ApiOfferType = {
    id: string;
    gencode: string;
    bannerText: string | null;
    highLight: boolean;
    promoShowEndDate: boolean;
    serieSpecial: string | null;
    roaming: boolean;
    networkText: string | null;
    nom_offre: string | null;
    sticker_color: string;
    prime: boolean;
    service_max: boolean;
}[];

export type ApiModalType = {
    id: number;
    bannerText: string;
    contentInsert: string;
    onOff: boolean;
    legalNotice: string;
    sticker_color: string;
    template: string;
    image: string;
    buttonText: string | null;
    buttonUrl: string | null;
    triggerInterval: string | null;
};

export type ApiBannerType = {
    title?: string;
    fagnonText?: string;
    urlRedirection?: string;
    legalNotice?: string;
    enabled: number;
    displayOrder: number;
};

export type ConfigType = {
    id: number;
    downloadBanner: boolean;
    lame_animco: boolean;
    termsConditions: boolean;
    error?: boolean;
    taux_ouverture_a: string;
    taux_ouverture_b: string;
    taux_ouverture_c: string;
    ab_test_panier_taux_ouverture: string;
    ab_test_paypal_taux_ouverture: string;
    offres_fai: {
        offre: string;
    }[];
    toaster_title?: string;
    toaster_description?: string;
    toaster_duration_ms?: number;
    toaster_icon?: string;
};

export type ApiSimTypeReturn = {
    parcours: ApiSimQuoteType[];
};

export type ApiSimQuoteType = {
    id: string;
    estCourant: boolean;
    simsCompatibles: ApiSimType[];
    prefereGencode?: string;
};

export type ApiSimType = {
    gencode: string;
    prefere: boolean;
    prix: number;
    typePrix: string;
    type: 'sim' | 'qr_esim';
};
export type ItemFacturationType = {
    codeClient: string;
    hashedIban?: string;
    compteBancaire: {
        bic: string;
        iban: string;
        nomBanque: string;
        titulaire: string;
    };

    devise: string;
    id: string;
    jourFacturation: number;
    ligneMarche: string;
    modePaiement: string;
    statut: string;
};

export type ApiFaqType = {
    items: {
        id: string;
        slug: string;
        questions: {
            question: string;
            reponse: string;
        }[];
    }[];
};

export type ProductsWithChildrenApiReturnType = {
    produits: { [key: string]: ApiOptionType | SapiPlanType };
};

export type SapicResponseTypeV5 = {
    produits: SapicProductTypeV5[];
    initiateur: string;
    nombreTotalProduits: number;
};
export type Promotion = {
    type: DiscountEnumType;
    valeur: number;
    reduction: number;
    estIncitation: boolean;
    estDifferee: boolean;
    duree: number;
    proprietesSupplementaires: {
        fanion?: string;
        typesMarketing: string[];
    };
    typesAccess: string[];
};

export type SapicProductTypeV5 = {
    ajoutsAutomatiquesFront?: string[];
    blocage?: string;
    categories: string[];
    couleurs?: string[] | null;
    connectivite?: SapicConnectivity;
    descriptionCourte?: string;
    dureeEngagement?: ObligationType;
    eligibilites?: string[];
    estEnStock?: boolean;
    excluAsso?: boolean;
    excluPro?: boolean;
    financements?: SapicFundingType[];
    gammeCommerciale?: string;
    gencode: string;
    libelleEnveloppeData: string;
    libelleEnveloppeVoix: string;
    medias?: string[];
    modesDeFinancement?: [];
    nom: string;
    note?: number;
    prix: {
        initial: number;
        pourToujours: number;
        final: number;
    };
    promotions?: Promotion[];
    quantite?: number;
    recommande?: boolean;
    technologie?: TECHNOLOGY;
    telephoneAvec?: string[];
    type: ProductTypeId;
    typePrix?: string;
    typeSim?: string;
    url: string;
    necessiteElements?: SapicNeededElement[];
};

export enum SapicConnectivity {
    FIVE_G = '5g',
    FOUR_G = '4g',
    FOUR_G_PLUS = '4g+',
}

export type SapicNeededElement = {
    alternatives: {
        typeCatalogue: string;
        categoriesComposantCommercial: string[];
        identifiant: string;
        libelle: string;
    }[];
};

export type SapicFundingType = {
    type: FundingEnumType;
    prefere: boolean;
    apportInitial: number;
    nbrEcheances: number;
    montantMensualite: number;
    tAEG: number;
    montantInteret: number;
    coutTotalFinancement: number;
    montantAFinancer: number;
    tauxDebiteurFixe?: number;
};

export type SapiProductChildType = Omit<SapiProductType, 'childs' | 'parentGencode' | 'product_ids'>;

export type SapiProductType = {
    gencode: string;
    type_id: ProductType | PlanTypeId;
    accessory_type?: string;
    audio_output?: string;
    auto_focus?: boolean;
    available_click_and_collect?: boolean;
    available_soon?: boolean;
    battery_capacity?: string;
    battery_removable?: boolean;
    battery_standby_time?: string;
    battery_talk_time?: string;
    bonus_recovery?: string;
    campaign_id?: string;
    capacity?: string;
    capacity_available?: string;
    capacity_sd?: string;
    categorie_sav: string;
    categories: string[];
    charger_output?: string;
    childs: Record<string, SapiProductChildType>;
    color: string;
    color_code: string;
    condition?: boolean;
    crossSellsProducts: string[];
    depth?: string;
    diagonal?: string;
    double_camera?: boolean;
    ecotax: string;
    entity_id: string;
    exclu_pro: boolean;
    exclu_web: boolean;
    features: string;
    final_price: number;
    first_page: boolean;
    good_deals: boolean;
    has_description: boolean;
    has_google_service_absent?: boolean;
    height?: string;
    image: string;
    in_stock: boolean;
    included?: string;
    incompatible_with?: [];
    is_highlighted: boolean;
    is_preorder: boolean;
    label?: string;
    label_img_fiche?: string;
    label_img_fiche_info?: string;
    length?: string;
    limbs_sar?: string;
    low_price?: boolean;
    manufacturer: string;
    manufacturer_code: string;
    material?: string;
    max_connection?: string;
    max_qty: number;
    medias: string[];
    memory_card_output?: string;
    meta_description?: string;
    name: string;
    non_included?: string;
    note_reparation?: string;
    note_reparation_pdf?: string;
    os?: string;
    os_version?: string;
    pack_content?: string;
    parentGencode?: string;
    phone_with?: boolean;
    phone_with_codes?: string;
    position: string;
    price: number;
    processor_core?: string;
    processor_speed?: string;
    product_ids: string[];
    qty: number;
    recovery_from_date?: string;
    recovery_to_date?: string;
    relatedProduct: [];
    resolution_height?: string;
    resolution_sensor?: string;
    resolution_width?: string;
    sar?: string;
    screen_technology?: string;
    selling_date: string;
    shipping_boundary_down?: string;
    shipping_boundary_up?: string;
    short_description: string;
    sim_multiple?: boolean;
    sim_type: string;
    sku: string;
    small_image: string;
    soon_exhausted: boolean;
    tax: number;
    thumbnail: string;
    title: string;
    to_scan: boolean;
    trunk_sar?: string;
    upSellsProducts: [];
    url: string;
    url_key: string;
    url_video?: string;
    weight?: string;
    width?: string;
    wifi?: boolean;
    odr?: {
        amount: string;
        file?: string;
    };
    from_abroad: string;
    double_sim: boolean;
    international_call: string;
    sms_mms?: string;
    commercial_range: string;
    data_envelope?: string;
    cms_popin_url?: string;
    obligation?: ObligationType;
    speed_down?: string;
    speed_up?: string;
};

export type SapiPlanType = {
    gencode: string;
    name: string;
    type_id: ProductTypeId;
    commercial_range: PlanRange;
    data_envelope?: string;
    data_size: number;
    low_prices_wall: boolean;
    from_abroad?: string;
    double_sim: boolean;
    is_darwin: boolean;
    sms_mms?: string;
    international_call?: string;
    max_connection?: SapicConnectivity;
    price: number;
    obligation?: ObligationType;
    url_key?: string;
    plan_flag?: string;
    catchy_description?: string;
    locked?: string;
    entity_id?: string;
    roaming_envelope: string;
};

export type SapiResponseType<T extends SapiProductType | SapiPlanType> = {
    produits: Record<string, T>;
};

export type SapicContextualisedProductV5Payload = {
    referenceExterneParcoursCible: string;
    panier: {
        catalogue: 'WEB';
        acheteur?: {
            type: 'NON_CONNU_GP' | 'PERSONNE' | 'NON_CONNU_PRO';
            noPersonne?: string;
        };
        parcours: {
            referenceExterne: string;
            typeParcours: QUOTE_TYPES;
            statut?: 'EN_COURS' | 'TERMINE';
            elements: {
                type: string;
                referenceExterne?: string;
                composantCommercial: {
                    identifiant: string;
                    typeCatalogue: 'BYTEL';
                };
            }[];
        }[];
    };
};

export enum QUOTE_TYPES {
    ACQUISITION = 'ACQUISITION',
    ACQUISITION_FIXE = 'ACQUISITION_FIXE',
}
